import { TFunction } from "i18next";
import { z } from "zod";

export const getDrasticEppnaFormSchema = (t: TFunction) => {
  return z.object({
    drasticDId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticRId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-r-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticAId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-a-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticSId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-s-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticTId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-t-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticIId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-i-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
    drasticCId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-c-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),

    eppnaId: z
      .number({
        required_error: t("calculations.vulnerability.drastic-eppna.errors.eppna-required"),
        invalid_type_error: t("calculations.vulnerability.drastic-eppna.errors.drastic-d-required"),
      }),
  });
};

export type DrasticEppnaForm = z.infer<ReturnType<typeof getDrasticEppnaFormSchema>>;